






























































import { Watch, Component, Prop, Vue } from 'vue-property-decorator'
import { Referral } from '@/api/model/referral'
import { Branch } from '@/api/model/branch'
import { User } from '@/api/model/user'
import { OrderStatus, OrderType } from '@/api/types'
import { OrderAPI, PipelineAPI } from '@/api/backend-client'
import { v4 as uuid } from 'uuid'
import { Order } from '@/api/model/order'
import { Pipeline } from '@/api/model/pipeline'

@Component
export default class CreateOrderModal extends Vue {
    @Prop({ required: true }) readonly referral!: Referral
    @Prop({ type: Boolean, default: false }) value!: boolean
    visible: boolean = false
    loading: boolean = false
    selectedType: OrderType = null
    selectedBranch: Branch = null
    selectedUser: User = null
    pipeline: Pipeline|null = null

    mounted(): void {
        this.loadReferralPipeline()
        this.autoSelectTypeForPipeline()
    }

    async loadReferralPipeline(): Promise<void> {
        if (!this.referral.pipeline) {
            return
        }

        this.pipeline = await PipelineAPI.get(this.referral.pipeline.id)
    }

    autoSelectTypeForPipeline() {
        if (!this.$currentCompany.pipelinesEnabled) {
            return
        }

        if (!this.referral.pipeline) {
            return
        }

        const type = this.$currentCompany.orderSettings.getMapping(this.referral.pipeline.id)
        if (type) {
            this.selectedType = type as OrderType
        }
    }

    @Watch('value')
    onValueChanged(): void {
        this.visible = this.value
    }

    @Watch('visible')
    onVisibleChanged(): void {
        this.$emit('input', this.visible)
    }

    async createOrder(): Promise<void> {
        try {
            this.loading = true

            await OrderAPI.create(Order.fromData({
                referral: this.referral.resourceIdentifier,
                id: uuid(),
                type: this.selectedType,
                orderStatus: OrderStatus.PENDING,
                assignedToBranch: this.selectedBranch ? this.selectedBranch.resourceIdentifier : null,
                assignedTo: this.selectedUser ? this.selectedUser.resourceIdentifier : null,
                transactionDate: null,
                transactionValue: null,
                orderValue: null,
                involvedUsers: this.referral.assignedTo ? [this.referral.assignedTo.resourceIdentifier] : [],
            }))

            this.$emit('on-save')
            this.hideModal()

        } finally {
            this.loading = false
        }
    }

    showModal(): void {
        this.visible = true
    }

    hideModal(): void {
        this.visible = false
    }

    get availableBranches(): Branch[] {
        if (this.pipeline) {
            return this.pipeline.branches
        }

        // Legacy
        return this.$currentCompany.getAvailableBranches()
            .filter(branch => branch.acceptsReferralType(this.referral.type))
    }

    get availableTypes(): Array<{ label: string, value: string }> {
        return this.$currentCompany.orderSettings.enabledTypes.map(type => {
            return {
                label: this.$t('referral.create-order.types.' + type).toString(),
                value: type,
            }
        })
    }

    get availableUsers(): User[] {
        if (this.selectedBranch === null) {
            return []
        }

        return this.$currentCompany.getAvailableUsers({
            branch: this.selectedBranch,
        })
    }
}
